// Tooltip anchor
function ShowTooltip() {

  $(".reference").each(function (index) {
    var thisReference = $(this);
    var tooltipItem = thisReference.find('.tooltip-ref');

    tooltipItem.css('transform', "none");

    var contentOffsetLeft = Math.round($('.block-section').offset().left);
    var tooltipOffsetLeft = Math.round(tooltipItem.offset().left);
    var contentOffsetRight = $(window).width() - (contentOffsetLeft + $('.block-section').outerWidth());
    var tooltipOffsetRight = $(window).width() - (tooltipOffsetLeft + tooltipItem.outerWidth());

    if (tooltipOffsetLeft < contentOffsetLeft) {
      tooltipItem.css('transform', "translateX(" + (contentOffsetLeft - tooltipOffsetLeft) + "px)");
    }

    if (tooltipOffsetRight < contentOffsetRight) {
      tooltipItem.css('transform', "translateX(" + -1 * (contentOffsetRight - tooltipOffsetRight) + "px)");
    }


    thisReference.on('mouseover', function () {
      $(this).addClass('active');
    });
    thisReference.on('mouseout', function () {
      $(this).removeClass('active');
    });

    thisReference.find('.close').on('click', function () {
      thisReference.removeClass('active');
    });
  });
}

$('.reference .js-scroll-nav').on('click', function () {
  var hash = $(location).attr('hash');

  $('.block-section .footer-anchor li').removeClass('active');
  $(hash).addClass('active');
});

$('.block-section .footer-anchor .js-scroll-nav').on('click', function () {
  $('.block-section .footer-anchor li').removeClass('active');
});

window.addEventListener('DOMContentLoaded', function(){
  ShowTooltip();
});

$(document).on('ready', function () {
  ShowTooltip();
});

$(window).on('resize', function () {
  ShowTooltip();
});